export enum ReservationStatus {
  Created = 'created',
  Ready = 'ready',
  Shipped = 'shipped',
  Canceled = 'canceled',
}
